// src/services/storageService.js

const STORAGE_KEY = "jangcoinUserChoice"; // Use a more unique key to avoid accidental overwrite

/**
 * Save user selection to localStorage.
 * @param {Object} choice - Object to persist (platform, payment, txId, sponsor, email, etc.)
 */
export function saveUserChoice(choice) {
  if (!choice) return;
  try {
    // Merge with existing data for incremental updates
    const existing = getUserChoice() || {};
    const merged = { ...existing, ...choice };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (err) {
    console.error("[StorageService] Error saving user choice:", err);
  }
}

/**
 * Retrieve user selection from localStorage.
 * @returns {Object} An object with saved fields, or {} if not set.
 */
export function getUserChoice() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.error("[StorageService] Error reading user choice:", err);
    return {};
  }
}

/**
 * Clear user selection from localStorage.
 */
export function clearUserChoice() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.error("[StorageService] Error clearing user choice:", err);
  }
}
